module.exports = __webpack_public_path__ + "static/media/LazyAz_android_2.5c90a786.jpg";